import { Col, Row, Spin, Typography } from "antd";
import DefaultImage from "assets/images/headerImage/EventsImage.png";
import axios from "axios";
import { ResponsibleMember, SanitizeHTML } from "@bindeleddet/core/components";
import { message } from "@bindeleddet/core/utils";
import { ActiveMember, Event, EventResponsibility } from "@bindeleddet/core/types";
import AboutCompany from "components/AboutCompany/AboutCompany";
import RelevantStudies from "components/RelevantStudies/RelevantStudies";
import { useViewport } from "@bindeleddet/core/hooks";
import EventHeader from "containers/SingleEventPage/EventHeader/EventHeader";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import { useEffect, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { formatTimeNorwegian, getDateComponentsNorwegian, getWeekdayNorwegian } from "helpers/dateUtils";

const { Title, Text } = Typography;

const months = ["JAN", "FEB", "MAR", "APR", "MAI", "JUN", "JUL", "AUG", "SEP", "OKT", "NOV", "DES"];
const days = ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"];

const SingleEventPage = () => {
  const [event, setEvent] = useState<Event>();
  // const [eventType, setEventType] = useState<EventType>(); */
  const [responsibles, setResponsibles] = useState<EventResponsibility[]>();
  const [mainResponsibleMember, setMainResponsibleMember] = useState<ActiveMember>();

  const { id } = useParams<{ id: string }>();
  const { width } = useViewport();
  const breakpoint = 992;

  const { currentUser, isLoadingCurrentUser } = useLoginContext();
  const history = useHistory();

  useEffect(() => {
    axios.get<Event>(`/events/all-events/${id}/`).then(response => {
      setEvent(response.data);
    });
  }, [id]);

  useEffect(
    function fetchResponsibles() {
      if (!event) return;
      axios.get<EventResponsibility[]>(`/events/${event.id}/event-responsibility/`).then(response => {
        setResponsibles(response.data);
      });
    },
    [event]
  );

  const mainResponsible = useMemo(() => responsibles?.find(r => r.responsibility_type === 1), [responsibles]);

  useEffect(
    function fetchMainResponsibleMember() {
      if (!mainResponsible?.bl_member) return;
      axios
        .get<ActiveMember>(`/internal/active-members/${mainResponsible.bl_member}/`)
        .then(response => setMainResponsibleMember(response.data));
    },
    [mainResponsible?.bl_member]
  );

  /*   useEffect(() => {
    axios.get<EventType>(`/events/event_type/${event?.event_type}/`).then(response => {
      setEventType(response.data);
    });
  }, [event]); */

  if (isLoadingCurrentUser) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!event) return null;

  const getLocation = () => {
    if (!event?.location?.name) return "Ikke bestemt";
    return event.location.name;
  };

  const getTime = () => {
    return formatTimeNorwegian(event.start);
  };

  const getDay = () => {
    return getWeekdayNorwegian(event.start);
  };

  const getDate = () => {
    const components = getDateComponentsNorwegian(event.start);
    if (components) {
      return components.day;
    }
    const fallbackDate = new Date(event.start);
    return fallbackDate.getDate();
  };

  const getMonth = () => {
    const components = getDateComponentsNorwegian(event.start);
    if (components) {
      return components.month;
    }
    const fallbackDate = new Date(event.start);
    return fallbackDate.getMonth();
  };

  if (!currentUser) {
    history.push("/");
    message("error", "Du må logge inn eller registrere deg for å åpne arrangementer");
    return null;
  }

  if (isCompanyUser(currentUser) && event.company.id !== currentUser.id) {
    history.push("/");
    message("error", "Bedrifter kan kun åpne egne arrangementer");
    return null;
  }

  return (
    <>
      <EventHeader
        imageLink={`${event?.coverImage ? event?.coverImage : DefaultImage}`}
        alt="EventImage"
        id={event?.id}
        month={months[getMonth()]}
        date={`${getDate()}`}
        dayAndTime={`${days[getDay()]} - kl. ${getTime()}`}
        location={`${getLocation()}`}
        open={event.open}
        name={event.name ?? event.company}
        isOpen={event.is_open}
        externalBookingUrl={event.external_booking_url}
      />
      <br />
      <Row style={{ paddingTop: "5%" }} justify="center">
        <Col
          xs={24}
          md={24}
          lg={13}
          style={
            width < breakpoint ? { paddingLeft: "10%", paddingRight: "10%" } : { paddingLeft: "4%", paddingRight: "7%" }
          }
        >
          <Title level={4}>Beskrivelse</Title>
          <Text>
            <b>Sted: </b> {`${getLocation()}`}
          </Text>
          <br />
          <Text>
            <b>Servering: </b> {event?.food ? event?.food : "Ikke bestemt"}
          </Text>
          <br />
          {event?.duration ? (
            <Text>
              <b>Varighet: </b> {event?.duration}
            </Text>
          ) : null}
          <br />
          <SanitizeHTML html={event?.comments} />
          <br />
        </Col>
        <Col
          xs={24}
          md={24}
          lg={8}
          style={width < breakpoint ? { paddingLeft: "10%", paddingRight: "10%" } : { paddingRight: "4%" }}
        >
          <RelevantStudies eventId={event.id} />
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: "7%" }}>
        <ResponsibleMember member={mainResponsibleMember} closeTime={getTime()} />
      </Row>
      <Row justify="center" style={{ paddingLeft: "10%", paddingRight: "10%", marginTop: "7%" }}>
        <AboutCompany company={event.company} />
      </Row>
      <br />
    </>
  );
};

export default SingleEventPage;
